import { AlertTriangle, Clipboard, Heart, Shield, TrendingDown } from "lucide-react";
import ApplicationPage, { type ApplicationPageConfig } from "@/components/ApplicationPage";

const config: ApplicationPageConfig = {
  key: "healthSafety",
  slug: "saude-seguranca",
  icon: Shield,
  useCases: [
    { key: "incidents", icon: AlertTriangle },
    { key: "inspections", icon: Clipboard },
    { key: "health", icon: Heart },
    { key: "risks", icon: TrendingDown },
  ],
  benefits: ["accidents", "compliance", "absences", "culture"],
  formApplication: "Saúde, Segurança e Meio Ambiente",
};

const SaudeSeguranca = () => <ApplicationPage config={config} />;

export default SaudeSeguranca;
